<div class="site-unity-filters">
  <form [formGroup]="filtersForm">
    <div class="filters-row">
      <!-- Sites Filter -->
      <div class="filter-group">
        <h3 class="filter-title">{{ 'common.sites' | translate }}</h3>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'common.sites' | translate }}</mat-label>
          <mat-select formControlName="sites" [multiple]="true">
            <mat-option *ngFor="let site of sites" [value]="site.id">
              {{ site.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Units Filter -->
      <div class="filter-group" *ngIf="filtersForm.get('sites')?.value?.length > 0">
        <h3 class="filter-title">{{ 'common.unities' | translate }}</h3>
        
        <!-- Loading indicator -->
        <div *ngIf="isLoadingUnities" class="loading-container">
          <mat-spinner diameter="24"></mat-spinner>
          <span class="loading-text">{{ 'common.loading' | translate }}</span>
        </div>

        <!-- Units selection grouped by site -->
        <mat-form-field appearance="outline" class="w-100" *ngIf="!isLoadingUnities && hasUnities()">
          <mat-label>{{ 'common.unities' | translate }}</mat-label>
          <mat-select formControlName="unities" [multiple]="true">
            <ng-container *ngFor="let siteId of filtersForm.get('sites')?.value; trackBy: trackBySiteId">
              <mat-optgroup [label]="getSiteLabel(siteId)" *ngIf="unitiesBySite[siteId]">
                <mat-option *ngFor="let unity of unitiesBySite[siteId]; trackBy: trackByUnityId" [value]="unity.id">
                  {{ unity.label }}
                </mat-option>
              </mat-optgroup>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <!-- No units message -->
        <div *ngIf="!isLoadingUnities && !hasUnities()" class="no-units-message">
          <mat-icon class="info-icon">info</mat-icon>
          <span>{{ 'filters.no_units_available' | translate }}</span>
        </div>
      </div>

      <!-- Actions - Moved to the same row -->
      <div class="filter-actions">
        <button 
          mat-stroked-button 
          color="primary" 
          type="button"
          (click)="resetFilters()"
          [disabled]="(!filtersForm.get('sites')?.value?.length && !filtersForm.get('unities')?.value?.length)">
          <mat-icon>clear_all</mat-icon>
          {{ 'common.reset_filter' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
